// extracted by mini-css-extract-plugin
export default {"wrapper":"userData_wrapper__0-fO7"};